import { lazy, Suspense } from 'react'
import announcements from './announcements'
import analytics from './analytics'
import auth from './auth'
import assets from './assets'
import blueprint from './blueprint'
import companies from './companies'
import confirmRole from './confirm-role'
import devices from './devices'
import inspectDevice from './inspect-device'
import installation from './installation'
import manufacturing from './manufacturing'
import mfa from './mfa'
import powersupplies from './powersupplies'
import projects from './projects'
import requestAccess from './request-access'
import ruuviTags from './ruuvi-tags'
import scan from './scan'
import users from './users'
import sms from './sms'
import heaters from './heaters'
import valves from './valves'

import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums/UserRole'
import { UserManualProvider } from '../contexts/userManual'
import AuthLayout from '../layouts/Auth'
import DashboardLayout from '../layouts/Dashboard'

const Dashboard = lazy(() => import('../pages/dashboards/Default'))
const UserManual = lazy(() => import('../pages/UserManual'))
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('../pages/TermsOfService'))
const Page404 = lazy(() => import('../pages/error/Page404'))

// Deprecated routes.
import DeviceGroups from '../pages/pages/DeviceGroups'
import Memberships from '../pages/pages/Memberships'
import Conditions from '../pages/pages/Conditions'
import Condition from '../pages/pages/Condition'
import Levels from '../pages/pages/Levels'
import Lifts from '../pages/pages/Lifts'
import Sectors from '../pages/pages/Sectors'
import { ConfluencePages } from '../enums'
import Changelog from '../pages/Changelog'
import LoadingState from '../components/LoadingState'

const routes = [
  {
    path: '/',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.GUEST,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.DASHBOARD}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Dashboard />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/user-manual',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <UserManual />
        </Suspense>
      </DashboardLayout>
    )
  },
  {
    path: '/privacy-policy',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <PrivacyPolicy />
        </Suspense>
      </DashboardLayout>
    )
  },
  {
    path: '/terms-of-service',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <TermsOfService />
        </Suspense>
      </DashboardLayout>
    )
  },
  {
    path: '/changelog',
    element: (
      <DashboardLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <Changelog />
        </Suspense>
      </DashboardLayout>
    )
  },

  ...analytics,
  ...announcements,
  ...auth,
  ...assets,
  ...blueprint,
  ...companies,
  ...confirmRole,
  ...devices,
  ...heaters,
  ...inspectDevice,
  ...installation,
  ...manufacturing,
  ...mfa,
  ...powersupplies,
  ...projects,
  ...requestAccess,
  ...ruuviTags,
  ...scan,
  ...users,
  ...sms,
  ...valves,

  /**
   * @deprecated
   */
  {
    path: '/device_groups',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <DeviceGroups />
        </DashboardLayout>
      </AuthGuard>
    )
  },

  /**
   * @deprecated
   */
  {
    path: '/memberships',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Memberships />
        </DashboardLayout>
      </AuthGuard>
    )
  },

  /**
   * @deprecated
   */
  {
    path: '/conditions',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: <Conditions />
      },
      {
        path: '*',
        element: <Condition />
      }
    ]
  },

  /**
   * @deprecated
   */
  {
    path: '/sectors',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Sectors />
        </DashboardLayout>
      </AuthGuard>
    )
  },

  /**
   * @deprecated
   */
  {
    path: '/lifts',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Lifts />
        </DashboardLayout>
      </AuthGuard>
    )
  },

  /**
   * @deprecated
   */
  {
    path: '/levels',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Levels />
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '*',
    element: (
      <AuthLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <Page404 />
        </Suspense>
      </AuthLayout>
    )
  }
]

export default routes
